<section>
  <div class="flex bg-gradient-to-r from-[#0b254e] to-[#154fa0] text-white">
    <div
      class="mx-auto w-full max-w-[1440px] gap-2 px-6 py-6 xl2:px-0"
      *ngxPermissionsOnly="[Permission.BILLING_READ]"
    >
      <app-analytics-widget class="flex-1">
        <app-ons-widget-summary />
      </app-analytics-widget>
    </div>
  </div>

  <div class="mx-auto mt-8 min-h-fit w-full max-w-[1440px] gap-2 px-6 xl2:px-0">
    <div class="mb-4" *ngxPermissionsOnly="[Permission.NITEL_IQ_PARTICIPANT]">
      <div
        class="mb-4 flex flex-col justify-center gap-2 sm:flex-row sm:justify-between"
      >
        <h1 class="font-bold">Network Status</h1>
        <div class="flex items-center justify-center">
          <app-toggle
            [ngModel]="(showMockData$ | async) ?? false"
            (ngModelChange)="showMockData$.next($event)"
            [label]="
              (showMockData$ | async)
                ? 'Switch to Real Data'
                : 'Switch to Sample Data'
            "
            size="md"
            color="primary"
          >
          </app-toggle>
        </div>
      </div>

      <div
        class="flex h-full flex-col gap-2 transition-all duration-300 ease-in-out md:flex-row"
      >
        <div class="w-full">
          <app-analytics-widget>
            <app-leaflet-map
              class="h-full"
              [categories]="categories()"
              [markers]="markers()"
            />
            @if (loading()) {
              <div
                class="pointer-events-none absolute inset-0 z-0 grid place-items-end"
              >
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
              </div>
            }
          </app-analytics-widget>
        </div>
      </div>
    </div>

    <div class="mb-4" *ngxPermissionsOnly="[Permission.NITEL_IQ_PARTICIPANT]">
      <app-ons-widget-observations
        [isLoading]="iqObservationsLoadings()"
        [observations]="observations()"
      />
    </div>

    <div class="mb-6 flex flex-col items-stretch gap-4 md:flex-row">
      <ng-container *ngxPermissionsOnly="Permission.TICKETING_READ">
        <app-analytics-widget class="min-w-0 flex-1 basis-0">
          <app-ons-widget-tickets [navigateOnClick]="true" />
        </app-analytics-widget>
      </ng-container>

      <ng-container *ngxPermissionsOnly="Permission.ORDERS">
        <app-analytics-widget class="min-w-0 flex-1 basis-0">
          <app-ons-widget-orders [navigateOnClick]="true" />
        </app-analytics-widget>
      </ng-container>

      <ng-container *ngxPermissionsOnly="Permission.SERVICES">
        <app-analytics-widget class="min-w-0 flex-1 basis-0">
          <app-ons-widget-services [navigateOnClick]="true" />
        </app-analytics-widget>
      </ng-container>
    </div>
  </div>
</section>
